import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Box,
  Typography,
  Paper,
  Modal,
  Backdrop,
  Fade,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Snackbar,
  Alert,
  useTheme,
  useMediaQuery,
  TextField,
  InputAdornment,
  BottomNavigation,
  BottomNavigationAction,
  Autocomplete,
  Badge,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import TableChartIcon from "@mui/icons-material/TableChart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import EventIcon from "@mui/icons-material/Event";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import FilterBar from "../../FilterSearch/FilterBarTables";
import { ThemeContext } from "../../../../../context/ThemeContextProvider";
import { fetchAllTables } from "../../../../../services/pos/Tables";
import { fetchPendingReservationForTable } from "../../../../../services/pos/reservation/reservationApi";
import TableModalContent from "../../MakeOrderResponsive/MobileMakeOrder/tables/TableModalContent";
import CreateOrderForm from "../../MakeOrder/tables/OrderDetails/Openorder/CreateOrderForm";
import { changeOrderStatus } from "../../../../../services/OrderStatus/OrderStatusApi";
import { useSettings } from "../../../../../context/SettingsContext";
import { usePermissions } from "../../../../../context/PermissionsAndFeatures/UserPermissionsContext";
import OrderItemsDialog from "./OrderItemsDialog";

const statusColors = {
  مفتوح: "#4CAF50",
  متاح: "#03A9F4",
  محجوز: "#F44336",
  "اوردر خارجي": "#fff",
};

const MobileTablesSection = () => {
  const { settings } = useSettings();
  const { permissions = {} } = usePermissions() || {};
  const canOpenTables = permissions["orders_tables_open_table"] === 1;

  const { mode } = useContext(ThemeContext);
  const [tables, setTables] = useState([]);
  const [filteredTables, setFilteredTables] = useState([]);
  const [activeTopTab, setActiveTopTab] = useState("all");
  const [filters, setFilters] = useState({ search: "", status: "", captain: "" });
  const [search, setSearch] = useState("");
  // NEW: حالة فلتر اختيار/كتابة رقم الطاولة
  const [tableFilter, setTableFilter] = useState("");
  // NEW: حالة فلتر الكابتن (يتم تعبئتها ديناميكياً من بيانات الطاولات)
  const [captainFilter, setCaptainFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // NEW: فلتر حالة الطاولة
  const [selectedTable, setSelectedTable] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectSubOrderModal, setSelectSubOrderModal] = useState(false);
  const [subOrders, setSubOrders] = useState([]);
  const [pendingTable, setPendingTable] = useState(null);
  const [pendingReservations, setPendingReservations] = useState({});
  const [showConfirmSuccess, setShowConfirmSuccess] = useState(false);
  const [showNoPermission, setShowNoPermission] = useState(false);

  const [reservationDialogOpen, setReservationDialogOpen] = useState(false);
  const [reservationDialogLoading, setReservationDialogLoading] = useState(false);
  const [reservationDialogData, setReservationDialogData] = useState([]);
  const [reservationDialogTable, setReservationDialogTable] = useState(null);

  // NEW: حالة Dialog عرض أصناف الأوردر
  const [orderItemsDialogOpen, setOrderItemsDialogOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const rootId = localStorage.getItem("branch_id");

  const enrichTables = (data, settingsArg) => {
    const alertBeforeMinutes = Number(
      settingsArg?.reservation_time ?? settingsArg?.reservation_alert_before ?? 60
    );

    return data.map((table) => {
      const order = table.order || {};
      let status = table.status ?? (table.available ? "متاح" : "مفتوح");

      let nearestReservation = null;
      if (Array.isArray(table.reservations) && table.reservations.length > 0) {
        const now = new Date();
        nearestReservation = table.reservations
          .map((r) => {
            const dt = new Date(`${r.reservation_date}T${r.reservation_time}`);
            return { ...r, dt, diffMinutes: Math.round((dt - now) / 60000) };
          })
          .filter((r) => r.diffMinutes >= 0)
          .sort((a, b) => a.diffMinutes - b.diffMinutes)[0];
      }

      if (
        nearestReservation &&
        nearestReservation.diffMinutes >= 0 &&
        nearestReservation.diffMinutes <= alertBeforeMinutes
      ) {
        status = "محجوز";
      }

      const orderStatus = order.status || order.order?.status || table.order?.status || "";
      const openTime =
        order.open_time ||
        order.openTime ||
        order.order?.open_time ||
        table.order?.open_time ||
        "";

      const hasSubOrders =
        Boolean(order.has_sub_orders) ||
        Boolean(order.hasSubOrders) ||
        (Array.isArray(order.sub_orders) && order.sub_orders.length > 0) ||
        Boolean(table.hasSubOrders);

      const subOrders = Array.isArray(order.sub_orders)
        ? order.sub_orders.map((s) => ({
            id: s.id,
            sub_table_name: s.sub_table_name || s.name || `فرعي ${s.id}`,
            open_time: s.open_time || s.openTime || "",
            customer: s.customer || "",
            total: s.total || 0,
            pending_items_count: s.pending_items_count ?? 0,
            ...s,
          }))
        : [];

      return {
        ...table,
        status,
        nearestReservation,
        customer: order.customer || "",
        captain: order.captain_name || "",
        total: order.total || 0,
        orderId: order.id || null,
        orderStatus,
        openTime,
        hasSubOrders,
        subOrders,
        // NEW: عدد الأصناف في الأوردر
        orderItemsCount: order.order_items_count ?? 0,
      };
    });
  };

  const loadTables = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchAllTables();
      const enriched = enrichTables(data, settings);
      setTables(enriched);
      if (activeTopTab === "under_review") {
        setFilteredTables(enriched.filter((t) => t.orderStatus === "under_review"));
      } else {
        setFilteredTables(enriched);
      }
    } catch (error) {
      console.error("❌ فشل في تحميل الطاولات:", error?.message || error);
    } finally {
      setLoading(false);
    }
  }, [settings, activeTopTab]);

  useEffect(() => {
    loadTables();
    const interval = setInterval(() => {
      loadTables();
    }, 9000000);
    return () => clearInterval(interval);
  }, [loadTables]);

  // استمع لأحداث التحديث بعد حفظ الفاتورة/تغيير الأوردر
  useEffect(() => {
    const handleUpdateEvent = (e) => {
      const detail = e?.detail || {};
      const { orderId, table_id } = detail || {};

      // تحديث سريع محلي للطاولة إن وُجد table_id
      if (table_id) {
        setTables((prev) =>
          prev.map((t) =>
            t.id === table_id
              ? {
                  ...t,
                  orderId: orderId || t.orderId,
                  status: orderId ? "مفتوح" : t.status,
                  available: orderId ? 0 : t.available,
                }
              : t
          )
        );
        setFilteredTables((prev) =>
          prev.map((t) =>
            t.id === table_id
              ? {
                  ...t,
                  orderId: orderId || t.orderId,
                  status: orderId ? "مفتوح" : t.status,
                  available: orderId ? 0 : t.available,
                }
              : t
          )
        );
      }

      // إعادة جلب البيانات كاملة لضمان التزامن
      loadTables();
    };

    window.addEventListener("mobileTablesSectionUpdated", handleUpdateEvent);
    window.addEventListener("tableModalContentUpdated", handleUpdateEvent);
    window.addEventListener("orderUpdated", handleUpdateEvent);

    return () => {
      window.removeEventListener("mobileTablesSectionUpdated", handleUpdateEvent);
      window.removeEventListener("tableModalContentUpdated", handleUpdateEvent);
      window.removeEventListener("orderUpdated", handleUpdateEvent);
    };
  }, [loadTables]);

  useEffect(() => {
    localStorage.setItem("current_component", "tables");
  }, []);

  window.updateTableData = (tableId) => {
    setTables((prev) =>
      prev.map((t) => (t.id === tableId ? { ...t, status: "مفتوح", available: 0 } : t))
    );
    setFilteredTables((prev) =>
      prev.map((t) => (t.id === tableId ? { ...t, status: "مفتوح", available: 0 } : t))
    );
  };

  // NEW: قائمة أرقام/أسماء الطاولات الفريدة للاستخدام في Autocomplete
  const uniqueTableNumbers = [...new Set(tables.map((t) => t.name?.toString()).filter(Boolean))].sort((a, b) => {
    const na = parseInt(a), nb = parseInt(b);
    if (!isNaN(na) && !isNaN(nb)) return na - nb;
    return a.localeCompare(b);
  });
  // NEW: قائمة الكباتن الفريدة مأخوذة من الطاولات (ديناميكي)
  const uniqueCaptains = [...new Set(tables.map((t) => (t.captain || "").toString()).filter(Boolean))].sort((a,b)=> a.localeCompare(b));
  // NEW: قائمة حالات الطاولات الفريدة للاستخدام في Autocomplete (ديناميكي)
  const uniqueStatuses = [...new Set(tables.map((t) => (t.status || "").toString()).filter(Boolean))].sort((a,b)=> a.localeCompare(b));

  useEffect(() => {
    // تطبيق سلسلة من الفلاتر: تاب أعلى -> فلتر الطاولة -> بحث المستخدم
    let filtered = tables.slice();

    if (activeTopTab === "under_review") {
      filtered = filtered.filter((t) => t.orderStatus === "under_review");
    }

    if (tableFilter && tableFilter.toString().trim() !== "") {
      const tf = tableFilter.toString().toLowerCase();
      filtered = filtered.filter(
        (t) => (t.name || "").toString().toLowerCase().includes(tf)
      );
    }

    // NEW: فلترة حسب الكابتن المختار (ديناميكي من الطاولات)
    if (captainFilter && captainFilter.toString().trim() !== "") {
      const cf = captainFilter.toString().toLowerCase();
      filtered = filtered.filter((t) => (t.captain || "").toString().toLowerCase().includes(cf));
    }

    // NEW: فلترة حسب حالة الطاولة
    if (statusFilter && statusFilter.toString().trim() !== "") {
      const sf = statusFilter.toString().toLowerCase();
      filtered = filtered.filter((t) => (t.status || "").toString().toLowerCase() === sf);
    }
    
    if (search && search.length > 0) {
      const s = search.toLowerCase();
      filtered = filtered.filter(
        (t) =>
          (t.customer || "").toString().toLowerCase().includes(s) ||
          (t.name || "").toString().toLowerCase().includes(s)
      );
    }

    setFilteredTables(filtered);
  }, [search, tables, activeTopTab, tableFilter, captainFilter, statusFilter]); // include statusFilter

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    const filtered = tables.filter((table) => {
      return (
        (newFilters.search === "" || (table.customer || "").includes(newFilters.search)) &&
        (newFilters.status === "" || table.status === newFilters.status) &&
        (newFilters.captain === "" || table.captain === newFilters.captain)
      );
    });
    setFilteredTables(filtered);
  };

  const handleTableClick = async (table) => {
    const updatedTable = tables.find((t) => t.id === table.id);
    if (!canOpenTables) {
      setShowNoPermission(true);
      return;
    }
    if (!updatedTable) return;

    if (updatedTable.hasSubOrders && updatedTable.order) {
      setPendingTable(updatedTable);
      const mainOrder = {
        id: updatedTable.orderId || updatedTable.order.id,
        sub_table_name:
          updatedTable.order.sub_table_name || updatedTable.name || `أساسي (${updatedTable.name || updatedTable.orderId || ""})`,
        open_time: updatedTable.openTime || updatedTable.order.open_time || updatedTable.order.openTime || "",
        customer: updatedTable.order.customer || updatedTable.customer || updatedTable.order.customer_name || "",
        total: updatedTable.order.total || updatedTable.total || 0,
        pending_items_count: updatedTable.order.pending_items_count ?? updatedTable.order.pending_items_count ?? 0,
        isMain: true,
      };
      const subOrdersList = [
        mainOrder,
        ...((Array.isArray(updatedTable.subOrders) ? updatedTable.subOrders : []).map((s) => ({
          id: s.id,
          sub_table_name: s.sub_table_name || `فرعي ${s.id}`,
          open_time: s.open_time || "",
          customer: s.customer || "",
          total: s.total || 0,
          pending_items_count: s.pending_items_count ?? 0,
          isMain: false,
        }))),
      ];
      setSubOrders(subOrdersList);
      setSelectSubOrderModal(true);
      return;
    }

    setSelectedTable(updatedTable);
    if (updatedTable.available === 1) {
      setModalType("createOrder");
      setIsModalOpen(true);
    } else {
      setOrderId(updatedTable.orderId);
      setModalType("addItem");
      setIsModalOpen(true);
    }
  };

  const handleSelectSubOrder = (orderObj) => {
    setSelectSubOrderModal(false);
    if (!pendingTable) return;
    setSelectedTable(pendingTable);
    setOrderId(orderObj.id);
    setModalType("addItem");
    setIsModalOpen(true);
    setPendingTable(null);
  };

  const refreshAndReopen = async () => {
    if (selectedTable) {
      setSelectedTable((prev) => ({ ...prev, orderId: orderId, status: "مفتوح" }));
      setModalType("addItem");
      setIsModalOpen(true);
    }
  };

  const handleOrderDeleteSuccess = () => {
    if (!selectedTable) return;
    const updatedTable = { ...selectedTable, status: "متاح", available: 1, orderId: null, customer: "", captain: "", total: "0", openDateTime: "", openTime: "", orderStatus: "" };
    const newTables = tables.map((t) => (t.id === updatedTable.id ? updatedTable : t));
    setTables(newTables);
    setFilteredTables(newTables);
    setSelectedTable(updatedTable);
    setIsModalOpen(false);
  };

  const handleShowReservations = async (table) => {
    setReservationDialogOpen(true);
    setReservationDialogTable(table);
    setReservationDialogLoading(true);
    try {
      const data = await fetchPendingReservationForTable(table.id);
      setReservationDialogData(Array.isArray(data) ? data : []);
    } catch {
      setReservationDialogData([]);
    }
    setReservationDialogLoading(false);
  };

  const handleConfirmExternalOrder = async (table) => {
    try {
      if (!table.orderId) {
        alert("لا يوجد رقم أوردر للطاولة!");
        return;
      }
      await changeOrderStatus(table.orderId, "pending");
      setShowConfirmSuccess(true);
    } catch (err) {
      alert("حدث خطأ أثناء تأكيد الأوردر الخارجي");
      console.error(err);
    }
  };

  const formatTime12 = (timeStr) => {
    if (!timeStr) return "-";
    const [h, m] = timeStr.split(":");
    let hour = Number(h || 0);
    const ampm = hour >= 12 ? "م" : "ص";
    hour = hour % 12 || 12;
    return `${hour}:${m || "00"} ${ampm}`;
  };

  // NEW: دالة فتح Dialog عرض الأصناف
  const handleOpenOrderItems = (orderId) => {
    setSelectedOrderId(orderId);
    setOrderItemsDialogOpen(true);
  };

  // NEW: دالة إغلاق Dialog عرض الأصناف
  const handleCloseOrderItems = () => {
    setOrderItemsDialogOpen(false);
    setSelectedOrderId(null);
  };

  // render only on mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallMobile = useMediaQuery("(max-width: 375px)");
  if (!isMobile) return null;

  const underReviewCount = tables.filter((t) => t.orderStatus === "under_review").length;

  // عدد الفلاتر النشطة
  const activeFiltersCount = [tableFilter, captainFilter, search, statusFilter].filter(Boolean).length;

  return (
    <Box sx={{ p: 1, bgcolor: mode === "dark" ? "#0f0f12" : "#fafafa", minHeight: "100vh", pb: 12 }}>
      {/* IMPROVED: شريط البحث والتبويبات - محسّن للموبايل */}
      <Paper
        elevation={2}
        sx={{
          mb: 1.5,
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: mode === "dark" ? "#1a1a2e" : "#fff",
        }}
      >
        {/* البحث السريع */}
        <Box sx={{ p: 1 }}>
          <TextField
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="ابحث بالعميل أو رقم الطاولة..."
            size="small"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 20, color: "text.secondary" }} />
                </InputAdornment>
              ),
              endAdornment: search && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearch("")}
                    sx={{ p: 0.5 }}
                  >
                    <ClearIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                bgcolor: mode === "dark" ? "#0f0f12" : "#f5f5f5",
                borderRadius: 1.5,
                fontSize: isSmallMobile ? 13 : 14,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              },
            }}
          />
        </Box>

        {/* فلاتر متقدمة */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            px: 1,
            pb: 1,
            flexWrap: "wrap",
          }}
        >
          {/* فلتر الطاولة */}
          <Box sx={{ flex: "1 1 45%", minWidth: isSmallMobile ? "100%" : "140px" }}>
            <Autocomplete
              freeSolo
              options={uniqueTableNumbers}
              value={tableFilter}
              onChange={(e, newVal) => setTableFilter(newVal || "")}
              onInputChange={(e, newInput) => setTableFilter(newInput)}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="طاولة..."
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <TableChartIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                      </InputAdornment>
                    ),
                    sx: {
                      bgcolor: mode === "dark" ? "#0f0f12" : "#f5f5f5",
                      fontSize: isSmallMobile ? 12 : 13,
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    },
                  }}
                />
              )}
              componentsProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-listbox": {
                      fontSize: isSmallMobile ? 12 : 13,
                    },
                  },
                },
              }}
            />
          </Box>

          {/* فلتر الكابتن */}
          <Box sx={{ flex: "1 1 45%", minWidth: isSmallMobile ? "100%" : "140px" }}>
            <Autocomplete
              freeSolo
              options={uniqueCaptains}
              value={captainFilter}
              onChange={(e, newVal) => setCaptainFilter(newVal || "")}
              onInputChange={(e, newInput) => setCaptainFilter(newInput)}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="كابتن..."
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <FilterListIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                      </InputAdornment>
                    ),
                    sx: {
                      bgcolor: mode === "dark" ? "#0f0f12" : "#f5f5f5",
                      fontSize: isSmallMobile ? 12 : 13,
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    },
                  }}
                />
              )}
              componentsProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-listbox": {
                      fontSize: isSmallMobile ? 12 : 13,
                    },
                  },
                },
              }}
            />
          </Box>

          {/* فلتر حالة الطاولة */}
          <Box sx={{ flex: "1 1 45%", minWidth: isSmallMobile ? "100%" : "140px" }}>
            <Autocomplete
              freeSolo
              options={uniqueStatuses}
              value={statusFilter}
              onChange={(e, newVal) => setStatusFilter(newVal || "")}
              onInputChange={(e, newInput) => setStatusFilter(newInput)}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="حالة الطاولة..."
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <TableChartIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                      </InputAdornment>
                    ),
                    sx: {
                      bgcolor: mode === "dark" ? "#0f0f12" : "#f5f5f5",
                      fontSize: isSmallMobile ? 12 : 13,
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                    },
                  }}
                />
              )}
              componentsProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-listbox": {
                      fontSize: isSmallMobile ? 12 : 13,
                    },
                  },
                },
              }}
            />
          </Box>

          {/* زر إعادة تعيين الفلاتر */}
          {activeFiltersCount > 0 && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<ClearIcon sx={{ fontSize: 14 }} />}
              onClick={() => {
                setTableFilter("");
                setCaptainFilter("");
                setSearch("");
                setStatusFilter(""); // reset status filter too
              }}
              sx={{
                minWidth: "auto",
                px: isSmallMobile ? 1.5 : 2,
                fontSize: isSmallMobile ? 11 : 12,
                height: isSmallMobile ? 36 : 38,
                bgcolor: mode === "dark" ? "#0f0f12" : "#f5f5f5",
                border: "none",
                color: "error.main",
                "&:hover": {
                  bgcolor: mode === "dark" ? "#1a1a2e" : "#e0e0e0",
                  border: "none",
                },
              }}
            >
              ({activeFiltersCount})
            </Button>
          )}
        </Box>

        {/* التبويبات */}
        <Box
          sx={{
            display: "flex",
            gap: 0.5,
            p: 1,
            pt: 0,
            bgcolor: mode === "dark" ? "#0f0f12" : "#f9f9f9",
            borderTop: `1px solid ${mode === "dark" ? "#2a2a3e" : "#e0e0e0"}`,
          }}
        >
          <Button
            fullWidth
            variant={activeTopTab === "all" ? "contained" : "text"}
            onClick={() => setActiveTopTab("all")}
            size="small"
            sx={{
              fontSize: isSmallMobile ? 11 : 12,
              fontWeight: activeTopTab === "all" ? 700 : 500,
              py: isSmallMobile ? 0.8 : 1,
              borderRadius: 1.5,
              textTransform: "none",
              minHeight: isSmallMobile ? 34 : 38,
              bgcolor:
                activeTopTab === "all"
                  ? undefined
                  : mode === "dark"
                  ? "transparent"
                  : "#fff",
              color: activeTopTab === "all" ? undefined : "text.secondary",
              "&:hover": {
                bgcolor:
                  activeTopTab === "all"
                    ? undefined
                    : mode === "dark"
                    ? "#1a1a2e"
                    : "#f5f5f5",
              },
            }}
          >
            كل الطاولات
          </Button>
          <Button
            fullWidth
            variant={activeTopTab === "under_review" ? "contained" : "text"}
            color={activeTopTab === "under_review" ? "warning" : "inherit"}
            onClick={() => setActiveTopTab("under_review")}
            size="small"
            sx={{
              fontSize: isSmallMobile ? 11 : 12,
              fontWeight: activeTopTab === "under_review" ? 700 : 500,
              py: isSmallMobile ? 0.8 : 1,
              borderRadius: 1.5,
              textTransform: "none",
              minHeight: isSmallMobile ? 34 : 38,
              bgcolor:
                activeTopTab === "under_review"
                  ? undefined
                  : mode === "dark"
                  ? "transparent"
                  : "#fff",
              color:
                activeTopTab === "under_review" ? undefined : "text.secondary",
              "&:hover": {
                bgcolor:
                  activeTopTab === "under_review"
                    ? undefined
                    : mode === "dark"
                    ? "#1a1a2e"
                    : "#f5f5f5",
              },
            }}
          >
            طلب خارجي ({underReviewCount})
          </Button>
        </Box>
      </Paper>

      {/* loading */}
      {loading && (
        <Box sx={{ position: "fixed", inset: 0, bgcolor: "rgba(0,0,0,0.35)", zIndex: 1400, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <CircularProgress size={56} />
        </Box>
      )}

      {/* list */}
      <List sx={{ mt: 0 }}>
        {filteredTables.map((table) => (
          <ListItem key={table.id} disablePadding sx={{ pb: 1 }}>
            <Paper elevation={2} sx={{ width: "100%", borderRadius: 2, overflow: "hidden" }}>
              <ListItemButton
                onClick={() => handleTableClick(table)}
                sx={{ display: "flex", flexDirection: "column", alignItems: "stretch", p: 1.25 }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography sx={{ fontWeight: 800, fontSize: 16 }}>
                      طاولة {table.name}
                    </Typography>

                    {/* NEW: أيقونة عدد الأصناف */}
                    {table.status !== "متاح" && table.orderItemsCount > 0 && (
                      <Badge
                        badgeContent={table.orderItemsCount}
                        color="error"
                        max={99}
                        sx={{
                          "& .MuiBadge-badge": {
                            fontSize: "9px",
                            fontWeight: 700,
                            minWidth: "16px",
                            height: "16px",
                            padding: "0 3px",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenOrderItems(table.orderId);
                        }}
                      >
                        <Box
                          sx={{
                            bgcolor: mode === "dark" ? "#1a1a2e" : "#fff",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            border: `1.5px solid ${mode === "dark" ? "#444" : "#e0e0e0"}`,
                            cursor: "pointer",
                            transition: "all 0.2s",
                            "&:active": {
                              transform: "scale(0.95)",
                            },
                          }}
                        >
                          <RestaurantMenuIcon
                            sx={{
                              fontSize: 14,
                              color: mode === "dark" ? "#fff" : "#666",
                            }}
                          />
                        </Box>
                      </Badge>
                    )}
                  </Box>

                  <Box sx={{ bgcolor: statusColors[table.status] || "#999", color: table.status === "اوردر خارجي" ? "#232334" : "#fff", px: 1.2, py: 0.5, borderRadius: 1.5, fontWeight: 700, fontSize: 13, display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                    {table.status}
                    {table.status === "محجوز" && <LockIcon sx={{ fontSize: 14 }} />}
                  </Box>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1, alignItems: "center", mb: 0.5 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: 13, color: mode === "dark" ? "#bbb" : "#666" }}>العميل: <strong>{table.customer || "-"}</strong></Typography>
                    <Typography sx={{ fontSize: 12, color: "#9e9e9e" }}>الكابتن: {table.captain || "-"}</Typography>
                  </Box>
                  <Box sx={{ textAlign: "right", minWidth: 72 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 15 }}>{table.status !== "متاح" ? table.total : "-"}</Typography>
                    <Typography sx={{ fontSize: 11, color: "#9e9e9e" }}>{formatTime12(table.openTime || table.openDateTime)}</Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 1, mt: 0.25 }}>
                  {table.status === "محجوز" && (
                    <Button size="small" startIcon={<VisibilityIcon />} onClick={(e) => { e.stopPropagation(); handleShowReservations(table); }} sx={{ flex: 1, minHeight: 44, borderRadius: 1 }}>
                      عرض الحجز
                    </Button>
                  )}

                  {table.status === "اوردر خارجي" && (
                    <Button variant="contained" color="success" onClick={(e) => { e.stopPropagation(); handleConfirmExternalOrder(table); }} sx={{ flex: 1, minHeight: 44, borderRadius: 1 }}>
                      تأكيد الأوردر
                    </Button>
                  )}

                  {table.available === 1 ? (
                    <Button variant="outlined" onClick={(e) => { e.stopPropagation(); setSelectedTable(table); setModalType("createOrder"); setIsModalOpen(true); }} sx={{ minHeight: 44, borderRadius: 1 }}>
                      فتح طاولة
                    </Button>
                  ) : (
                    <Button variant="outlined" onClick={(e) => { e.stopPropagation(); setSelectedTable(table); setOrderId(table.orderId); setModalType("addItem"); setIsModalOpen(true); }} sx={{ minHeight: 44, borderRadius: 1 }}>
                      إدارة الأوردر
                    </Button>
                  )}
                </Box>

                {table.nearestReservation && (
                  <Box sx={{ mt: 1 }}>
                    <Typography sx={{ fontSize: 12, color: "#ff9800", fontWeight: 700 }}>
                      {table.nearestReservation.diffMinutes > 0 ? (table.nearestReservation.diffMinutes < 60 ? `بعد ${table.nearestReservation.diffMinutes} د` : `${Math.floor(table.nearestReservation.diffMinutes / 60)} س`) : "الآن"}
                    </Typography>
                  </Box>
                )}
              </ListItemButton>
            </Paper>
          </ListItem>
        ))}
      </List>

      {/* snackbars */}
      <Snackbar open={showConfirmSuccess} autoHideDuration={3500} onClose={() => setShowConfirmSuccess(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="success" sx={{ fontSize: 14, fontWeight: 700 }}>✅ تم تأكيد الأوردر!</Alert>
      </Snackbar>

      <Snackbar open={showNoPermission} autoHideDuration={3000} onClose={() => setShowNoPermission(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" onClose={() => setShowNoPermission(false)} sx={{ fontSize: 13, fontWeight: 700 }}>ليس لديك صلاحية لفتح الطاولة.</Alert>
      </Snackbar>

      {/* reservation dialog */}
      <Dialog open={reservationDialogOpen} onClose={() => setReservationDialogOpen(false)} fullScreen>
        <DialogTitle>حجوزات الطاولة {reservationDialogTable?.name ? `(${reservationDialogTable.name})` : ""}</DialogTitle>
        <DialogContent>
          {reservationDialogLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}><CircularProgress /></Box>
          ) : reservationDialogData.length === 0 ? (
            <Typography color="text.secondary" align="center" sx={{ my: 2 }}>لا توجد حجوزات معلقة.</Typography>
          ) : (
            <Box sx={{ mt: 1 }}>
              {reservationDialogData.map((r) => (
                <Paper key={r.id} sx={{ p: 1, mb: 1 }}>
                  <Typography><strong>{r.reservation_date}</strong> — {(() => { const [h, m] = r.reservation_time.split(":"); let hour = Number(h); const ampm = hour >= 12 ? "م" : "ص"; hour = hour % 12 || 12; return `${hour}:${m} ${ampm}`; })()}</Typography>
                  <Typography>الاشخاص: {r.number_of_people} — الحالة: {r.status === "pending" ? "معلق" : r.status}</Typography>
                  <Typography sx={{ color: "#777" }}>{r.note || "-"}</Typography>
                </Paper>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions><Button onClick={() => setReservationDialogOpen(false)}>إغلاق</Button></DialogActions>
      </Dialog>

      {/* sub-order selection */}
      <Dialog open={selectSubOrderModal} onClose={() => setSelectSubOrderModal(false)} fullScreen>
        <DialogTitle sx={{ fontWeight: 700, textAlign: "center" }}>اختر الأوردر</DialogTitle>
        <DialogContent>
          <List>
            {subOrders.map((order) => (
              <ListItem key={order.id} disablePadding>
                <ListItemButton onClick={() => handleSelectSubOrder(order)} sx={{ py: 2 }}>
                  <ListItemText primary={order.sub_table_name} secondary={order.isMain ? "الأوردر الأساسي" : ""} primaryTypographyProps={{ fontWeight: 700 }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions><Button onClick={() => setSelectSubOrderModal(false)}>إلغاء</Button></DialogActions>
      </Dialog>

      {/* main modal full screen */}
      <Modal open={isModalOpen} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 300 }}>
        <Fade in={isModalOpen}>
          <Box sx={{ position: "fixed", inset: 0, bgcolor: mode === "dark" ? "#0f0f12" : "#fff", p: 0, overflowY: "auto" }}>
            <Box sx={{ position: "sticky", top: 0, zIndex: 1200, display: "flex", justifyContent: "flex-end", p: 1 }}>
              <IconButton onClick={() => setIsModalOpen(false)}><CloseIcon /></IconButton>
            </Box>
            <Box sx={{ p: 1 }}>
              {modalType === "createOrder" && (
                <CreateOrderForm
                  tableId={selectedTable?.id}
                  rootId={rootId}
                  hasReservation={selectedTable?.reservation === 1}
                  onSuccess={(newOrder) => {
                    setIsModalOpen(false);
                    setTables((prev) => prev.map((t) => t.id === selectedTable?.id ? { ...t, orderId: newOrder.id, status: "مفتوح", customer: newOrder.customer || "", captain: newOrder.captain_name || "", total: newOrder.total || 0, openDateTime: new Date().toLocaleString(), openTime: newOrder.open_time || newOrder.openTime || new Date().toLocaleTimeString(), orderStatus: newOrder.status || "" } : t));
                    setFilteredTables((prev) => prev.map((t) => t.id === selectedTable?.id ? { ...t, orderId: newOrder.id, status: "مفتوح", customer: newOrder.customer || "", captain: newOrder.captain_name || "", total: newOrder.total || 0, openDateTime: new Date().toLocaleString(), openTime: newOrder.open_time || newOrder.openTime || new Date().toLocaleTimeString(), orderStatus: newOrder.status || "" } : t));
                    setSelectedTable((prev) => prev ? { ...prev, orderId: newOrder.id, status: "مفتوح", customer: newOrder.customer || "", captain: newOrder.captain_name || "", total: newOrder.total || 0, openDateTime: new Date().toLocaleString(), openTime: newOrder.open_time || newOrder.openTime || new Date().toLocaleTimeString(), orderStatus: newOrder.status || "" } : prev);
                    setOrderId(newOrder.id);
                    setModalType("addItem");
                    setIsModalOpen(true);
                  }}
                />
              )}
              {modalType === "addItem" && (
                <TableModalContent
                  type="addItem"
                  tableId={selectedTable?.id}
                  rootId={rootId}
                  orderId={orderId}
                  onSuccess={refreshAndReopen}
                  onClose={() => setIsModalOpen(false)}
                  onOrderDeleted={handleOrderDeleteSuccess}
                />
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* NEW: Dialog عرض أصناف الأوردر */}
      <OrderItemsDialog
        open={orderItemsDialogOpen}
        onClose={handleCloseOrderItems}
        orderId={selectedOrderId}
      />

      {/* bottom navigation quick access */}
      <Box sx={{ position: "fixed", bottom: 10, left: "50%", transform: "translateX(-50%)", width: "calc(100% - 20px)", maxWidth: 720 }}>
        <Paper elevation={8} sx={{ borderRadius: 3, overflow: "hidden" }}>
          <BottomNavigation showLabels value={activeTopTab === "all" ? 0 : 1} onChange={(e, val) => setActiveTopTab(val === 0 ? "all" : "under_review")}>
            <BottomNavigationAction label="الطاولات" icon={<TableChartIcon />} />
            <BottomNavigationAction label="طلبات خارجي" icon={<LocalShippingIcon />} />
          </BottomNavigation>
        </Paper>
      </Box>
    </Box>
  );
};

export default MobileTablesSection;